import React, { useState, useCallback, useEffect } from 'react';
import { Container, Link } from '@hpstellar/core';

import './seo-tabs.less';

export default ({ tabs, isBot }) => {
    const [activeTab, setActiveTab] = useState(-1);
    //prevent re-rendering content by tracking render state
    const [renderMap, setRenderMap] = useState({});
    useEffect(() => {
        if (activeTab > -1 && !renderMap[activeTab]) {
            setRenderMap({ ...renderMap, [activeTab]: true });
        }
    }, [activeTab]);
    if (!tabs || tabs.length < 1) {
        return null;
    }
    const onClick = useCallback((idx, activeTab) => () => {
        if (idx === activeTab) {
            setActiveTab(-1);
        } else {
            setActiveTab(idx);
        }
    });

    return (
        <Container className="seo-tabs">
            <div className="seo-tab-list">
                {tabs.map((t, idx) => {
                    const { gtmActions } = t;
                    const { category, id, value } = gtmActions || {};
                    return (
                        <Link
                            key={t.label}
                            tag="button"
                            data-gtm-category={category}
                            data-gtm-id={id}
                            data-gtm-value={value}
                            color="dark"
                            onClick={onClick(idx, activeTab)}
                            isCap={true}
                            isActive={idx === activeTab}
                            icon="angle"
                        >
                            {t.label}
                        </Link>
                    );
                })}
            </div>
            {tabs.map((t, idx) => {
                const isActiveIndx = idx === activeTab;
                if (!isBot && !isActiveIndx && !renderMap[idx]) {
                    return null;
                }
                return (
                    <div key={t.label} className={`seo-tab-content${isActiveIndx ? ' active' : ''}`}>
                        {t.content}
                    </div>
                );
            })}
        </Container>
    );
};
